import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/residents/resident-registration";

export const Route = createFileRoute("/admin/_residents/resident-registration")(
  {
    component: Page,
  }
);
